import { Zap, Shield, Book } from 'lucide-react'
import { type JSX } from 'react'

export type SubscriptionPlanContent = {
	title: string
	price: string
	oldPrice?: string
	period: string
	subtitle: string
	public: boolean
	usage: {
		chats?: string
		expedientes?: string
		transcription?: string
	}
	resources: {
		chat: number
		analysis: number
		transcription: number
	}
	featured: boolean
	cta: string
	ctaStright: string
	icon?: JSX.ElementType
	link: string
}

export const SubscriptionPlans: Record<string, SubscriptionPlanContent> = {
	basic: {
		title: 'Básico',
		subtitle: 'Empiece a conocer la plataforma',
		price: '29.95',
		period: '/mes',
		usage: {
			chats: '50 consultas jurídicas con IA por mes',
			expedientes: '3 análisis de expedientes legales por mes',
			transcription: '20 horas transcripciones por mes',
		},
		resources: {
			chat: 50,
			analysis: 3,
			transcription: 20 * 60,
		},
		featured: false,
		cta: 'Comenzar ahora',
		ctaStright: 'Pagar este plan',
		public: true,
		icon: Shield,
		link: '',
	},
	advanced: {
		title: 'Avanzado',
		subtitle: 'La elección inteligente para profesionales establecidos',
		price: '99.95',
		oldPrice: '119.95',
		period: '/mes',
		usage: {
			chats: '250 consultas jurídicas con IA por mes',
			expedientes: '10 análisis de expedientes legales por mes',
			transcription: '80 horas de transcripciones por mes',
		},
		resources: {
			chat: 250,
			analysis: 10,
			transcription: 80 * 60,
		},
		featured: true,
		public: true,
		cta: 'Potencia tu práctica',
		ctaStright: 'Pagar este plan',
		icon: Zap,
		link: '',
	},
	student: {
		title: 'Para Estudiantes',
		subtitle: 'Precio de descuento para estudiantes',
		price: '12.95',
		period: '/mes',
		usage: {
			chats: '20 exámenes de práctica con IA por mes',
		},
		resources: {
			chat: 20,
			analysis: 0,
			transcription: 0,
		},
		icon: Book,
		featured: true,
		public: true,
		cta: 'Comenzar ahora',
		ctaStright: 'Pagar este plan',
		link: '',
	},
}

export const plansForStudents = ['student']
export const plansForNormalUsers = ['basic', 'advanced']

for (const planName in SubscriptionPlans) {
	SubscriptionPlans[planName]!.link = createLinkFor(SubscriptionPlans[planName]!.title)
}

export type ShowSubscriptionPlan = (typeof SubscriptionPlans)[keyof typeof SubscriptionPlans]

export const features = [
	{
		name: 'Auri: asistente con toda la jurisprudencia y normativa de Costa Rica, con citas verificables',
		includedIn: ['basic', 'advanced', 'student'],
	},
	{
		name: 'Buscador Legal: normativa, resoluciones, Contraloría (CGR) y Tribunal Registral (TRA)',
		includedIn: ['basic', 'advanced', 'student'],
	},
	{
		name: 'Redactor Inteligente: escritos y contratos desde los códigos vigentes; exporta a PDF y Word',
		includedIn: ['basic', 'advanced', 'student'],
	},
	{
		name: 'Análisis de expedientes: cronología, casos similares, probabilidad de éxito y estrategia',
		includedIn: ['basic', 'advanced'],
	},
	{
		name: 'Tablas IA: extraiga datos de cientos de documentos, con cita y confianza por celda',
		includedIn: ['basic', 'advanced'],
	},
	{
		name: 'Playbooks por lote: revise hasta 1.000 documentos contra sus propios criterios',
		includedIn: ['basic', 'advanced'],
	},
	{
		name: 'Agentes: automatice trabajos jurídicos repetitivos en pasos reutilizables',
		includedIn: ['basic', 'advanced'],
	},
]

function createLinkFor(planName: string) {
	return `/payments/generate-link?typeOfPayment=subscription&planName=${planName}`
}
